import {
	LayoutDashboard,
	TrendingUp,
	ShoppingCart,
	BarChart3,
	Activity,
	FileText,
	Menu,
	X
} from 'lucide-react';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const API_BASE = import.meta.env.VITE_API_BASE_URL || '';

function getEnvironment(): { label: string; color: string } {
	if (!API_BASE) return { label: 'LOCAL', color: 'bg-text-muted/20 text-text-muted' };
	if (API_BASE.includes('testnet'))
		return { label: 'TESTNET', color: 'bg-warning/20 text-warning' };
	return { label: 'PRODUCTION', color: 'bg-success/20 text-success' };
}

const env = getEnvironment();

const navItems = [
	{ path: '/', label: 'Overview', icon: LayoutDashboard },
	{ path: '/positions', label: 'Positions', icon: TrendingUp },
	{ path: '/orders', label: 'Orders', icon: ShoppingCart },
	{ path: '/markets', label: 'Markets', icon: BarChart3 },
	{ path: '/logs', label: 'Logs', icon: FileText }
];

export function Navigation() {
	const [isOpen, setIsOpen] = useState(false);
	const location = useLocation();

	return (
		<nav className="bg-surface border-b border-border">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex justify-between h-16">
					<div className="flex items-center">
						<Link to="/" className="flex items-center gap-2">
							<Activity className="h-6 w-6 text-primary" />
							<span className="font-bold text-lg">TA Trader</span>
						</Link>
						<span className={`ml-3 px-2 py-0.5 rounded text-xs font-medium ${env.color}`}>
							{env.label}
						</span>
					</div>

					{/* Desktop Navigation */}
					<div className="hidden md:flex items-center space-x-1">
						{navItems.map((item) => {
							const Icon = item.icon;
							const isActive =
								location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
							return (
								<Link
									key={item.path}
									to={item.path}
									className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
										isActive
											? 'bg-primary/10 text-primary'
											: 'text-text-muted hover:text-text hover:bg-surface-hover'
									}`}
								>
									<Icon className="h-4 w-4" />
									{item.label}
								</Link>
							);
						})}
					</div>

					{/* Mobile menu button */}
					<div className="flex items-center md:hidden">
						<button
							onClick={() => setIsOpen(!isOpen)}
							className="p-2 rounded-lg text-text-muted hover:text-text hover:bg-surface-hover"
						>
							{isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
						</button>
					</div>
				</div>
			</div>

			{/* Mobile Navigation */}
			{isOpen && (
				<div className="md:hidden border-t border-border">
					<div className="px-2 pt-2 pb-3 space-y-1">
						{navItems.map((item) => {
							const Icon = item.icon;
							const isActive =
								location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
							return (
								<Link
									key={item.path}
									to={item.path}
									onClick={() => setIsOpen(false)}
									className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
										isActive
											? 'bg-primary/10 text-primary'
											: 'text-text-muted hover:text-text hover:bg-surface-hover'
									}`}
								>
									<Icon className="h-4 w-4" />
									{item.label}
								</Link>
							);
						})}
					</div>
				</div>
			)}
		</nav>
	);
}
